import { render, staticRenderFns } from "./MidPayCollectForm.vue?vue&type=template&id=dc925d42&scoped=true&"
import script from "./MidPayCollectForm.vue?vue&type=script&lang=js&"
export * from "./MidPayCollectForm.vue?vue&type=script&lang=js&"
import style0 from "./MidPayCollectForm.vue?vue&type=style&index=0&id=dc925d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc925d42",
  null
  
)

export default component.exports